import { render, staticRenderFns } from "./videoDoctorDialog.vue?vue&type=template&id=e4c89926&scoped=true"
import script from "./videoDoctorDialog.vue?vue&type=script&lang=js"
export * from "./videoDoctorDialog.vue?vue&type=script&lang=js"
import style0 from "./videoDoctorDialog.vue?vue&type=style&index=0&id=e4c89926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c89926",
  null
  
)

export default component.exports